import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { DataInputHeader } from './components/DataInputHeader';
import { DataInputWorkflow } from './components/DataInputWorkflow';
import { useOcrInputStore } from './store/ocrInputStore';

export const OcrDataInputPage: React.FC = () => {
    const resetAll = useOcrInputStore(state => state.resetAll);

    useEffect(() => {
        return () => {
            resetAll();
        }
    }, []);

    return (
        <Box
            sx={{
                height: 'calc(100% - 24px)',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography variant="title" gutterBottom>OCR Data Input</Typography>
            <DataInputHeader />
            <DataInputWorkflow />
        </Box>
    );
};